import React from 'react';
import { Headphones, ArrowRight, Check, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useAuth } from '../../context/AuthContext';

const CustomerSupportPage = () => {
  const { login } = useAuth();

  const features = [
    'Suporte 24/7 automatizado',
    'Escalação inteligente',
    'Histórico de conversas',
    'Respostas com IA',
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-28 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
                <Headphones className="h-4 w-4" />
                Suporte ao Cliente
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                <span className="text-[#3b82f6]">Suporte ao cliente</span> automatizado
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Ofereça atendimento de qualidade 24/7 com chatbots inteligentes que resolvem problemas.
              </p>
              <Button onClick={login} size="lg" className="bg-[#3b82f6] hover:bg-[#2563eb]">
                Começar gratuitamente
              </Button>
            </div>
            <div className="bg-gray-50 rounded-3xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#3b82f6] rounded-full flex items-center justify-center">
                  <Headphones className="h-5 w-5 text-white" />
                </div>
                <div>
                  <p className="font-semibold">Suporte ChatAlfa</p>
                  <p className="text-xs text-green-500">Online agora</p>
                </div>
              </div>
              <div className="space-y-3">
                <div className="bg-[#3b82f6] text-white rounded-xl rounded-tl-none p-3 max-w-[80%]">
                  <p className="text-sm">Olá! Como posso ajudar você hoje?</p>
                </div>
                <div className="bg-white border rounded-xl rounded-tr-none p-3 max-w-[80%] ml-auto">
                  <p className="text-sm">Meu pedido não chegou</p>
                </div>
                <div className="bg-[#3b82f6] text-white rounded-xl rounded-tl-none p-3 max-w-[80%]">
                  <p className="text-sm">Vou verificar o status agora mesmo! 📦</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50 py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Recursos</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {features.map((feature) => (
                <div key={feature} className="bg-white rounded-xl p-6 shadow-sm">
                  <Check className="h-6 w-6 text-green-500 mb-3" />
                  <p className="font-medium text-gray-900">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="bg-gradient-to-br from-[#3b82f6] to-[#1d4ed8] text-white">
              <CardContent className="py-12 text-center">
                <h2 className="text-2xl font-bold mb-4">Melhore seu suporte ao cliente</h2>
                <Button onClick={login} variant="secondary" size="lg" className="bg-white text-[#3b82f6] hover:bg-gray-100">
                  Começar agora <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CustomerSupportPage;
